import React from 'react';
import { cn } from 'lib/utils';

/**
 * SidebarSection - A section divider with optional title for sidebar navigation
 * Shows title when expanded, shows a simple divider line when collapsed
 */
export default function SidebarSection({
  title,
  collapsed = false,
  className,
  children,
}) {
  return (
    <div className={cn('mt-4', className)}>
      {/* Section Header */}
      {collapsed ? (
        // Collapsed: Simple divider line
        <div className="mx-3 mb-2 border-t border-neutral-300 dark:border-neutral-700/50" />
      ) : (
        // Expanded: Title with subtle line
        <div className="mb-2 flex items-center gap-2 px-4">
          <span className="text-[10px] font-semibold uppercase tracking-wider text-neutral-600 dark:text-neutral-400">
            {title}
          </span>
          <div className="h-px flex-1 bg-neutral-300 dark:bg-neutral-700/50" />
        </div>
      )}

      {/* Section Content */}
      {children}
    </div>
  );
}
